module.exports = "/_next/static/images/7e81ed8bfb6d19faf609d61a73a98fbd-woman-with-yellow-glasses@3x.jpg.webp";